export const getDealEntityDetails = (existing: any, incoming: any, args) => {
   if (!existing) return incoming
   if (args?.params.pagination.offset === 0) return incoming

   const prevDeals = [...(existing.deals || [])]

   const newDeals = [...(incoming.deals || [])]

   const filterPrevDeals = prevDeals.filter(prevDeal => {
      const availableDeal = newDeals.find(
         newDeal =>
            // eslint-disable-next-line no-underscore-dangle
            prevDeal.__ref === newDeal.__ref
      )
      return !availableDeal
   })

   const finalDeals = [...filterPrevDeals, ...newDeals]

   return {
      ...existing,
      deals: finalDeals,
      totalCount: incoming.totalCount
   }
}

export const getPipelineItemRemarksDetails = (
   existing: any,
   incoming: any,
   args
) => {
   if (!existing) return incoming
   if (args?.params.pagination.offset === 0) return incoming

   const prevRemarks = [...(existing.remarks || [])]
   const newRemarks = [...(incoming.remarks || [])]

   const filterPrevRemarks = prevRemarks.filter(prevRemark => {
      const availableDeal = newRemarks.find(
         newRemark =>
            // eslint-disable-next-line no-underscore-dangle
            prevRemark.__ref === newRemark.__ref
      )

      return !availableDeal
   })

   const finalRemarks = [...filterPrevRemarks, ...newRemarks]

   return {
      ...existing,
      remarks: finalRemarks,
      totalCount: incoming.totalCount
   }
}

export const getAllAWs = (existing: any, incoming: any, args) => {
   if (!existing) return incoming
   if (args?.params.pagination.offset === 0) return incoming

   const existingAutomationWorkflows = [...(existing.automationWorkflows || [])]
   const newAutomationWorkflows = [...(incoming.automationWorkflows || [])]

   const filterPrevAutomationWorkflows = existingAutomationWorkflows.filter(
      existingAutomationWorkflow => {
         const availableAutomationWorkflows = newAutomationWorkflows.find(
            newAutomationWorkflow =>
               // eslint-disable-next-line no-underscore-dangle
               existingAutomationWorkflow.__ref ===
               // eslint-disable-next-line no-underscore-dangle
               newAutomationWorkflow.__ref
         )
         return !availableAutomationWorkflows
      }
   )

   const finalAutomationWorkflows = [
      ...filterPrevAutomationWorkflows,
      ...newAutomationWorkflows
   ]

   return {
      ...existing,
      automationWorkflows: finalAutomationWorkflows,
      totalCount: incoming.totalCount
   }
}

export const getAccountLeadDistributionRules = (
   existing: any,
   incoming: any,
   args
) => {
   if (!existing) return incoming
   if (args?.params.pagination.offset === 0) return incoming

   const existingRecordDistributionRules = [
      ...(existing.leadDistributionRules || [])
   ]
   const newRecordDistributionRules = [
      ...(incoming.leadDistributionRules || [])
   ]

   const filterExistingRecordDistributionRules = existingRecordDistributionRules.filter(
      existingRecordDistributionRule => {
         const availableRecordDistributionRules = newRecordDistributionRules.find(
            newRecordDistributionRule =>
               // eslint-disable-next-line no-underscore-dangle
               existingRecordDistributionRule.__ref ===
               // eslint-disable-next-line no-underscore-dangle
               newRecordDistributionRule.__ref
         )
         return !availableRecordDistributionRules
      }
   )

   const finalRecordDistributionRules = [
      ...filterExistingRecordDistributionRules,
      ...newRecordDistributionRules
   ]

   return {
      ...existing,
      leadDistributionRules: finalRecordDistributionRules,
      totalCount: incoming.totalCount
   }
}

export const getAccountLeadDistributionRuleExecLogs = (
   existing: any,
   incoming: any,
   args
) => {
   if (!existing) return incoming
   if (args?.params.pagination.offset === 0) return incoming

   const existingExecutionLogs = [...(existing.execLogs || [])]
   const newExecutionLogs = [...(incoming.execLogs || [])]

   const filterExistingExecutionLogs = existingExecutionLogs.filter(
      existingExecutionLog => {
         const availableExecutionLogs = newExecutionLogs.find(
            newExecutionLog =>
               // eslint-disable-next-line no-underscore-dangle
               existingExecutionLog.__ref ===
               // eslint-disable-next-line no-underscore-dangle
               newExecutionLog.__ref
         )
         return !availableExecutionLogs
      }
   )

   const finalExecutionLogs = [
      ...filterExistingExecutionLogs,
      ...newExecutionLogs
   ]

   return {
      ...existing,
      execLogs: finalExecutionLogs,
      totalCount: incoming.totalCount
   }
}

export const getUserDashboards = (existing: any, incoming: any, args) => {
   if (!existing) return incoming
   if (args?.params.pagination.offset === 0) return incoming

   const existingUserDashboards = [...(existing.dashboards || [])]

   const newUserDashboards = [...(incoming.dashboards || [])]

   const filterExistingUserDashboards = existingUserDashboards.filter(
      existingUserDashboard => {
         const availableUserDashboards = newUserDashboards.find(
            newUserDashboard =>
               // eslint-disable-next-line no-underscore-dangle
               existingUserDashboard.__ref ===
               // eslint-disable-next-line no-underscore-dangle
               newUserDashboard.__ref
         )
         return !availableUserDashboards
      }
   )

   const finalUserDashboards = [
      ...filterExistingUserDashboards,
      ...newUserDashboards
   ]

   return {
      ...existing,
      dashboards: finalUserDashboards,
      totalCount: incoming.totalCount
   }
}

export const searchUserGroups = (existing: any, incoming: any, args) => {
   if (!existing) return incoming
   if (args?.params.pagination.offset === 0) return incoming

   const existingUserGroups = [...(existing.userGroups || [])]

   const newUserGroups = [...(incoming.userGroups || [])]

   const filterExistingUserGroups = existingUserGroups.filter(
      existingUserGroups => {
         const availableUserGroups = newUserGroups.find(
            newUserGroups =>
               // eslint-disable-next-line no-underscore-dangle
               existingUserGroups.__ref ===
               // eslint-disable-next-line no-underscore-dangle
               newUserGroups.__ref
         )
         return !availableUserGroups
      }
   )

   const finalUserGroups = [...filterExistingUserGroups, ...newUserGroups]

   return {
      ...existing,
      userGroups: finalUserGroups,
      totalCount: incoming.totalCount
   }
}

export const getAccountAutomationWorkflowExecLogs = (
   existing: any,
   incoming: any,
   args
) => {
   if (!existing) return incoming
   if (args?.params.pagination.offset === 0) return incoming

   const prevLogs = [...(existing.automationWorkflowExecLogs || [])]

   const newLogs = [...(incoming.automationWorkflowExecLogs || [])]

   const filterPrevLogs = prevLogs.filter(prevRem => {
      const availableLog = newLogs.find(
         newRem =>
            // eslint-disable-next-line no-underscore-dangle
            prevRem.__ref === newRem.__ref
      )
      return !availableLog
   })

   const finalLogs = [...filterPrevLogs, ...newLogs]

   return {
      ...existing,
      automationWorkflowExecLogs: finalLogs,
      totalCount: incoming.totalCount
   }
}

export const getDataExportRequests = (existing: any, incoming: any, args) => {
   if (!existing) return incoming
   if (args?.params.pagination.offset === 0) return incoming

   const existingDataExportRequests = [...(existing.dataExportRequests || [])]

   const newDataExportRequests = [...(incoming.dataExportRequests || [])]

   const filterExistingDataExportRequests = existingDataExportRequests.filter(
      existingDataExportRequests => {
         const availableDataExportRequests = newDataExportRequests.find(
            newDataExportRequests =>
               // eslint-disable-next-line no-underscore-dangle
               existingDataExportRequests.__ref ===
               // eslint-disable-next-line no-underscore-dangle
               newDataExportRequests.__ref
         )
         return !availableDataExportRequests
      }
   )

   const finalDataExportRequests = [
      ...filterExistingDataExportRequests,
      ...newDataExportRequests
   ]

   return {
      ...existing,
      dataExportRequests: finalDataExportRequests,
      totalCount: incoming.totalCount
   }
}

export const getFailedTrackActivityLogs = (
   existing: any,
   incoming: any,
   args
) => {
   if (!existing) return incoming
   if (args?.params.pagination.offset === 0) return incoming

   const existingFailedActivityLogs = [...(existing.activityLogs || [])]

   const newFailedActivityLogs = [...(incoming.activityLogs || [])]

   const filterExistingFailedActivityLogs = existingFailedActivityLogs.filter(
      existingFailedActivityLog => {
         const availableDataExportRequests = newFailedActivityLogs.find(
            newFailedActivityLog =>
               // eslint-disable-next-line no-underscore-dangle
               existingFailedActivityLog.__ref ===
               // eslint-disable-next-line no-underscore-dangle
               newFailedActivityLog.__ref
         )
         return !availableDataExportRequests
      }
   )

   const finalFailedActivityLogs = [
      ...filterExistingFailedActivityLogs,
      ...newFailedActivityLogs
   ]

   return {
      ...existing,
      activityLogs: finalFailedActivityLogs,
      totalCount: incoming.totalCount
   }
}

export const searchActivityTemplates = (existing: any, incoming: any, args) => {
   if (!existing) return incoming
   if (args?.params.pagination.offset === 0) return incoming

   const existingActivityReferenceIds = [...(existing.activityTemplates || [])]

   const newActivityReferenceIds = [...(incoming.activityTemplates || [])]

   const filterExistingActivityReferenceIds = existingActivityReferenceIds.filter(
      existingExistingActivityReferenceId => {
         const availableActivityReferenceIds = newActivityReferenceIds.find(
            newActivityReferenceId =>
               // eslint-disable-next-line no-underscore-dangle
               existingExistingActivityReferenceId.__ref ===
               // eslint-disable-next-line no-underscore-dangle
               newActivityReferenceId.__ref
         )
         return !availableActivityReferenceIds
      }
   )

   const finalActivityReferenceIds = [
      ...filterExistingActivityReferenceIds,
      ...newActivityReferenceIds
   ]

   return {
      ...existing,
      activityTemplates: finalActivityReferenceIds,
      totalCount: incoming.totalCount
   }
}

export const getGlobalSearchResults = (existing: any, incoming: any, args) => {
   if (!existing) return incoming
   if (args?.params.pagination.offset === 0) return incoming

   const existingDataSearchResults = [...(existing.pipelineItems || [])]

   const newDataSearchResults = [...(incoming.pipelineItems || [])]

   const filterExistingDataSearchResults = existingDataSearchResults.filter(
      existingDataSearchResults => {
         const availableDataSearchResults = newDataSearchResults.find(
            newDataSearchResults =>
               // eslint-disable-next-line no-underscore-dangle
               existingDataSearchResults.__ref ===
               // eslint-disable-next-line no-underscore-dangle
               newDataSearchResults.__ref
         )
         return !availableDataSearchResults
      }
   )

   const finalSearchResults = [
      ...filterExistingDataSearchResults,
      ...newDataSearchResults
   ]

   return {
      ...existing,
      pipelineItems: finalSearchResults,
      totalCount: incoming.totalCount
   }
}

export const getUsersInAccount = (existing: any, incoming: any, args) => {
   if (!existing) return incoming
   if (args?.params.pagination.offset === 0) return incoming

   const existingUsers = [...(existing.users || [])]
   const incomingUsers = [...(incoming.users || [])]

   const filterExistingUsers = existingUsers.filter(existingUser => {
      const availableUser = incomingUsers.find(
         // eslint-disable-next-line no-underscore-dangle
         incomingUser => existingUser.__ref === incomingUser.__ref
      )
      return !availableUser
   })

   const mergedUsers = [...filterExistingUsers, ...incomingUsers]

   return {
      ...existing,
      users: mergedUsers,
      totalCount: incoming.totalCount
   }
}
export const getIdentificationsInAccount = (
   existing: any,
   incoming: any,
   args
) => {
   if (!existing) return incoming
   if (!args.params.pagination) return incoming
   if (args.params.pagination.offset === 0) return incoming

   const existingIdentificationsInAccount = [
      ...(existing.identifications || [])
   ]

   const newIdentificationsInAccount = [...(incoming.identifications || [])]

   const filterExistingIdentifications = existingIdentificationsInAccount.filter(
      existingIdentificationsInAccount => {
         const availableIdentifications = newIdentificationsInAccount.find(
            newIdentificationsInAccount =>
               // eslint-disable-next-line no-underscore-dangle
               existingIdentificationsInAccount.__ref ===
               // eslint-disable-next-line no-underscore-dangle
               newIdentificationsInAccount.__ref
         )

         return !availableIdentifications
      }
   )

   const finalIdentifications = [
      ...filterExistingIdentifications,
      ...newIdentificationsInAccount
   ]

   return {
      ...existing,
      identifications: finalIdentifications,
      totalCount: incoming.totalCount
   }
}

export const searchLeadCreationAllowedStages = (
   existing: any,
   incoming: any,
   args
) => {
   if (!existing) return incoming
   if (args?.params.pagination.offset === 0) return incoming

   const existingLeadAllowedStageResults = [...(existing.stages || [])]

   const newLeadAllowedStageResults = [...(incoming.stages || [])]

   const filteredLeadAllowedStageResults = existingLeadAllowedStageResults.filter(
      existingLeadAllowedStageResults => {
         const availableDataSearchResults = newLeadAllowedStageResults.find(
            newLeadAllowedStageResults =>
               // eslint-disable-next-line no-underscore-dangle
               existingLeadAllowedStageResults.__ref ===
               // eslint-disable-next-line no-underscore-dangle
               newLeadAllowedStageResults.__ref
         )
         return !availableDataSearchResults
      }
   )

   const finalLeadAllowedStageResults = [
      ...filteredLeadAllowedStageResults,
      ...newLeadAllowedStageResults
   ]
   return {
      ...existing,
      stages: finalLeadAllowedStageResults,
      totalCount: incoming.totalCount
   }
}

export const searchFields = (existing: any, incoming: any, args) => {
   if (!existing) return incoming
   if (args?.params.pagination.offset === 0) return incoming

   const existingLeadAllowedStageResults = [
      ...(existing.salesTemplateFields || [])
   ]

   const newLeadAllowedStageResults = [...(incoming.salesTemplateFields || [])]

   const filteredLeadAllowedStageResults = existingLeadAllowedStageResults.filter(
      existingLeadAllowedStageResults => {
         const availableDataSearchResults = newLeadAllowedStageResults.find(
            newLeadAllowedStageResults =>
               // eslint-disable-next-line no-underscore-dangle
               existingLeadAllowedStageResults.__ref ===
               // eslint-disable-next-line no-underscore-dangle
               newLeadAllowedStageResults.__ref
         )
         return !availableDataSearchResults
      }
   )

   const finalLeadAllowedStageResults = [
      ...filteredLeadAllowedStageResults,
      ...newLeadAllowedStageResults
   ]
   return {
      ...existing,
      salesTemplateFields: finalLeadAllowedStageResults
   }
}
export const getDataLoadingRequests = (existing: any, incoming: any, args) => {
   if (!existing) return incoming
   if (args?.params.pagination.offset === 0) return incoming

   const existingDataLoadingRequests = [...(existing.dataLoadingRequests || [])]
   const incomingDataLoadingRequests = [...(incoming.dataLoadingRequests || [])]

   const filterExistingDataLoadingRequests = existingDataLoadingRequests.filter(
      existingDataLoadingRequest => {
         const availableDataLoadingRequest = incomingDataLoadingRequests.find(
            incomingDataLoadingRequest =>
               // eslint-disable-next-line no-underscore-dangle
               existingDataLoadingRequest.__ref ===
               // eslint-disable-next-line no-underscore-dangle
               incomingDataLoadingRequest.__ref
         )

         return !availableDataLoadingRequest
      }
   )

   const finalDataLoadingRequests = [
      ...filterExistingDataLoadingRequests,
      ...incomingDataLoadingRequests
   ]

   return {
      ...existing,
      dataLoadingRequests: finalDataLoadingRequests,
      totalCount: incoming.totalCount
   }
}

export const searchIdentifications = (existing: any, incoming: any, args) => {
   if (!existing) return incoming
   if (args?.params.pagination.offset === 0) return incoming

   const existingIdentifications = [...(existing.identifications || [])]
   const incomingIdentifications = [...(incoming.identifications || [])]

   const filterExistingIdentifications = existingIdentifications.filter(
      existingIdentification => {
         const availableIdentification = incomingIdentifications.find(
            incomingIdentification =>
               // eslint-disable-next-line no-underscore-dangle
               existingIdentification.__ref ===
               // eslint-disable-next-line no-underscore-dangle
               incomingIdentification.__ref
         )
         return !availableIdentification
      }
   )

   const finalIdentifications = [
      ...filterExistingIdentifications,
      ...incomingIdentifications
   ]
   return {
      ...existing,
      identifications: finalIdentifications,
      totalCount: incoming.totalCount
   }
}

export const getRelatedObjects = (existing: any, incoming: any, args) => {
   if (!existing) return incoming
   if (args?.params.pagination.offset === 0) return incoming

   const existingRelatedObjects = [...(existing.relatedObjects || [])]
   const incomingRelatedObjects = [...(incoming.relatedObjects || [])]

   const filterExistingRelatedObjects = existingRelatedObjects.filter(
      existingRelatedObject => {
         const availableRelatedObject = incomingRelatedObjects.find(
            incomingRelatedObject =>
               // eslint-disable-next-line no-underscore-dangle
               existingRelatedObject.__ref ===
               // eslint-disable-next-line no-underscore-dangle
               incomingRelatedObject.__ref
         )

         return !availableRelatedObject
      }
   )

   const finalRelatedObjects = [
      ...filterExistingRelatedObjects,
      ...incomingRelatedObjects
   ]

   return {
      ...existing,
      relatedObjects: finalRelatedObjects,
      totalCount: incoming.totalCount
   }
}

export const getPipelineManualLeadDistributionExecLogs = (
   existing: any,
   incoming: any,
   args
) => {
   if (!existing) return incoming
   if (args?.params.pagination.offset === 0) return incoming

   const existingPipelineManualLeadDistributionExecLogs = [
      ...(existing.execLogs || [])
   ]
   const incomingPipelineManualLeadDistributionExecLogs = [
      ...(incoming.execLogs || [])
   ]

   const filterExistingPipelineManualLeadDistributionExecLogs = existingPipelineManualLeadDistributionExecLogs.filter(
      existingPipelineManualLeadDistributionExecLog => {
         const availablePipelineManualLeadDistributionExecLog = incomingPipelineManualLeadDistributionExecLogs.find(
            incomingPipelineManualLeadDistributionExecLog =>
               // eslint-disable-next-line no-underscore-dangle
               existingPipelineManualLeadDistributionExecLog.__ref ===
               // eslint-disable-next-line no-underscore-dangle
               incomingPipelineManualLeadDistributionExecLog.__ref
         )

         return !availablePipelineManualLeadDistributionExecLog
      }
   )

   const finalPipelineManualLeadDistributionExecLogs = [
      ...filterExistingPipelineManualLeadDistributionExecLogs,
      ...incomingPipelineManualLeadDistributionExecLogs
   ]

   return {
      ...existing,
      execLogs: finalPipelineManualLeadDistributionExecLogs,
      totalCount: incoming.totalCount
   }
}

export const getRelatedObjectsToLink = (
   existing: any,
   incoming: any,
   args: any
) => {
   if (!existing) return incoming
   if (args?.params.pagination.offset === 0) return incoming

   const existingRelatedObjectsToLink = [...(existing.relatedObjects || [])]
   const incomingRelatedObjectsToLink = [...(incoming.relatedObjects || [])]

   const filterExistingRelatedObjectsToLink = existingRelatedObjectsToLink.filter(
      existingRelatedObject => {
         const availableRelatedObjectToLink = incomingRelatedObjectsToLink.find(
            incomingRelatedObject =>
               // eslint-disable-next-line no-underscore-dangle
               existingRelatedObject.__ref ===
               // eslint-disable-next-line no-underscore-dangle
               incomingRelatedObject.__ref
         )

         return !availableRelatedObjectToLink
      }
   )

   const finalRelatedObjectsToLink = [
      ...filterExistingRelatedObjectsToLink,
      ...incomingRelatedObjectsToLink
   ]

   return {
      ...existing,
      relatedObjects: finalRelatedObjectsToLink,
      totalCount: incoming.totalCount
   }
}

export const getPipelineEventBasedLeadDistributionExecLogs = (
   existing: any,
   incoming: any,
   args: any
) => {
   if (!existing) return incoming
   if (args?.params.pagination.offset === 0) return incoming

   const existingPipelineEventBasedLeadDistributionExecLogs = [
      ...(existing.execLogs || [])
   ]
   const incomingPipelineEventBasedLeadDistributionExecLogs = [
      ...(incoming.execLogs || [])
   ]

   const filterExistingPipelineEventBasedLeadDistributionExecLogs = existingPipelineEventBasedLeadDistributionExecLogs.filter(
      existingPipelineEventBasedLeadDistributionExecLog => {
         const availablePipelineEventBasedLeadDistributionExecLog = incomingPipelineEventBasedLeadDistributionExecLogs.find(
            incomingPipelineEventBasedLeadDistributionExecLog =>
               // eslint-disable-next-line no-underscore-dangle
               existingPipelineEventBasedLeadDistributionExecLog.__ref ===
               // eslint-disable-next-line no-underscore-dangle
               incomingPipelineEventBasedLeadDistributionExecLog.__ref
         )

         return !availablePipelineEventBasedLeadDistributionExecLog
      }
   )

   const finalPipelineEventBasedLeadDistributionExecLogs = [
      ...filterExistingPipelineEventBasedLeadDistributionExecLogs,
      ...incomingPipelineEventBasedLeadDistributionExecLogs
   ]

   return {
      ...existing,
      execLogs: finalPipelineEventBasedLeadDistributionExecLogs,
      totalCount: incoming.totalCount
   }
}

export const getPipelineScheduledLeadDistributionExecLogs = (
   existing: any,
   incoming: any,
   args: any
) => {
   if (!existing) return incoming
   if (args?.params.pagination.offset === 0) return incoming

   const existingPipelineScheduledLeadDistributionExecLogs = [
      ...(existing.execLogs || [])
   ]
   const incomingPipelineScheduledLeadDistributionExecLogs = [
      ...(incoming.execLogs || [])
   ]

   const filterExistingPipelineScheduledLeadDistributionExecLogs = existingPipelineScheduledLeadDistributionExecLogs.filter(
      existingPipelineScheduledLeadDistributionExecLog => {
         const availablePipelineScheduledLeadDistributionExecLog = incomingPipelineScheduledLeadDistributionExecLogs.find(
            incomingPipelineScheduledLeadDistributionExecLog =>
               // eslint-disable-next-line no-underscore-dangle
               existingPipelineScheduledLeadDistributionExecLog.__ref ===
               // eslint-disable-next-line no-underscore-dangle
               incomingPipelineScheduledLeadDistributionExecLog.__ref
         )
         return !availablePipelineScheduledLeadDistributionExecLog
      }
   )

   const finalPipelineScheduledLeadDistributionExecLogs = [
      ...filterExistingPipelineScheduledLeadDistributionExecLogs,
      ...incomingPipelineScheduledLeadDistributionExecLogs
   ]

   return {
      ...existing,
      execLogs: finalPipelineScheduledLeadDistributionExecLogs,
      totalCount: incoming.totalCount
   }
}

export const getWatiAccountPluginServiceAccounts = (
   existing: any,
   incoming: any,
   args: any
) => {
   if (!existing) return incoming

   if (args?.params.pagination.offset === 0) return incoming

   const existingWATIAccounts = [...(existing.watiAccounts || [])]
   const incomingWATIAccounts = [...(incoming.watiAccounts || [])]

   const filterExistingWATIAccounts = existingWATIAccounts.filter(
      existingWATIAccount => {
         const availableWATIAccount = incomingWATIAccounts.find(
            incomingWATIAccount =>
               // eslint-disable-next-line no-underscore-dangle
               existingWATIAccount.__ref === incomingWATIAccount.__ref
         )
         return !availableWATIAccount
      }
   )

   const finalWATIAccounts = [
      ...filterExistingWATIAccounts,
      ...incomingWATIAccounts
   ]

   return {
      ...existing,
      watiAccounts: finalWATIAccounts,
      totalCount: incoming.totalCount
   }
}

export const getGallaboxAccountPluginServiceAccounts = (
   existing: any,
   incoming: any,
   args: any
) => {
   if (!existing) return incoming

   if (args?.params.pagination.offset === 0) return incoming

   const existingAccounts = [...(existing.gallaboxAccounts || [])]
   const incomingAccounts = [...(incoming.gallaboxAccounts || [])]

   const filterExistingAccounts = existingAccounts.filter(existingAccounts => {
      const availableWATIAccount = incomingAccounts.find(
         incomingAccounts =>
            // eslint-disable-next-line no-underscore-dangle
            existingAccounts.__ref === incomingAccounts.__ref
      )
      return !availableWATIAccount
   })

   const finalAccounts = [...filterExistingAccounts, ...incomingAccounts]

   return {
      ...existing,
      gallaboxAccounts: finalAccounts,
      totalCount: incoming.totalCount
   }
}

export const getGupShupAccountPluginServiceAccounts = (
   existing: any,
   incoming: any,
   args: any
) => {
   if (!existing) return incoming

   if (args?.params.pagination.offset === 0) return incoming

   const existingAccounts = [...(existing.gupshupAccounts || [])]
   const incomingAccounts = [...(incoming.gupshupAccounts || [])]

   const filterExistingAccounts = existingAccounts.filter(existingAccounts => {
      const availableGupShupAccount = incomingAccounts.find(
         incomingAccounts =>
            // eslint-disable-next-line no-underscore-dangle
            existingAccounts.__ref === incomingAccounts.__ref
      )
      return !availableGupShupAccount
   })

   const finalAccounts = [...filterExistingAccounts, ...incomingAccounts]

   return {
      ...existing,
      gupshupAccounts: finalAccounts,
      totalCount: incoming.totalCount
   }
}
export const getWhatsappBusinessNumbers = (
   existing: any,
   incoming: any,
   args: any
) => {
   if (!existing) return incoming
   if (args?.params.pagination.offset === 0) return incoming

   const existingWhatsappBusinessNumbers = [
      ...(existing.whatsappBusinessNumbers || [])
   ]
   const incomingWhatsappBusinessNumbers = [
      ...(incoming.whatsappBusinessNumbers || [])
   ]

   const filterExistingWhatsappBusinessNumbers = existingWhatsappBusinessNumbers.filter(
      existingWhatsappBusinessNumber => {
         const availableWhatsappBusinessNumber = incomingWhatsappBusinessNumbers.find(
            incomingWhatsappBusinessNumber =>
               // eslint-disable-next-line no-underscore-dangle
               existingWhatsappBusinessNumber.__ref ===
               // eslint-disable-next-line no-underscore-dangle
               incomingWhatsappBusinessNumber.__ref
         )
         return !availableWhatsappBusinessNumber
      }
   )

   const finalWhatsappBusinessNumbers = [
      ...filterExistingWhatsappBusinessNumbers,
      ...incomingWhatsappBusinessNumbers
   ]

   return {
      ...existing,
      whatsappBusinessNumbers: finalWhatsappBusinessNumbers,
      totalCount: incoming.totalCount
   }
}

export const getPipelineItemMessageTemplates = (
   existing: any,
   incoming: any,
   args: any
) => {
   if (!existing) return incoming
   if (args.params.pagination.offset === 0) return incoming

   const prevMessageTemplates = [...(existing.messageTemplates || [])]
   const newMessageTemplates = [...(incoming.messageTemplates || [])]

   const filteredPrevMessageTemplates = prevMessageTemplates.filter(
      prevTemplate => {
         const availableMessageTemplates = newMessageTemplates.find(
            // eslint-disable-next-line no-underscore-dangle
            newTemplate => prevTemplate.__ref === newTemplate.__ref
         )
         return !availableMessageTemplates
      }
   )

   const finalMessageTemplates = [
      ...filteredPrevMessageTemplates,
      ...newMessageTemplates
   ]

   return {
      ...existing,
      messageTemplates: finalMessageTemplates,
      totalCount: incoming.totalCount
   }
}

export const getAgentsForManager = (
   existing: any,
   incoming: any,
   args: any
) => {
   if (!existing) return incoming
   if (args.params.pagination.offset === 0) return incoming

   const existingAgents = [...(existing.agents || [])]
   const incomingAgents = [...(incoming.agents || [])]

   const filteredAgents = existingAgents.filter(existingAgent => {
      const availableAgent = incomingAgents.find(
         incomingAgent =>
            // eslint-disable-next-line no-underscore-dangle
            existingAgent.__ref === incomingAgent.__ref
      )
      return !availableAgent
   })

   const finalAgents = [...filteredAgents, ...incomingAgents]

   return {
      ...existing,
      agents: finalAgents,
      totalCount: incoming.totalCount
   }
}

export const getRelatedPipelineItemRemarks = (
   existing: any,
   incoming: any,
   args
) => {
   if (!existing) return incoming
   if (args?.params.pagination.offset === 0) return incoming

   const prevRemarks = [...(existing.remarks || [])]
   const newRemarks = [...(incoming.remarks || [])]

   const filterPrevRemarks = prevRemarks.filter(prevRemark => {
      const availableDeal = newRemarks.find(
         newRemark =>
            // eslint-disable-next-line no-underscore-dangle
            prevRemark.__ref === newRemark.__ref
      )

      return !availableDeal
   })

   const finalRemarks = [...filterPrevRemarks, ...newRemarks]

   return {
      ...existing,
      remarks: finalRemarks,
      totalCount: incoming.totalCount
   }
}

export const getAccountScheduledAutomationWorkflowLogs = (
   existing: any,
   incoming: any,
   args
) => {
   if (!existing) return incoming
   if (args?.params.pagination.offset === 0) return incoming

   const prevLogs = [...(existing.execLogs || [])]
   const newLogs = [...(incoming.execLogs || [])]

   const filterPrevLogs = prevLogs.filter(prevLog => {
      const availableLog = newLogs.find(
         newLog =>
            // eslint-disable-next-line no-underscore-dangle
            prevLog.__ref === newLog.__ref
      )
      return !availableLog
   })

   const finalLogs = [...filterPrevLogs, ...newLogs]

   return {
      ...existing,
      execLogs: finalLogs,
      totalCount: incoming.totalCount
   }
}

export const getUserNotifications = (existing: any, incoming: any, args) => {
   if (!existing) return incoming
   if (args?.params.pagination.offset === 0) return incoming

   const prevNotifications = [...(existing.notifications || [])]
   const newNotifications = [...(incoming.notifications || [])]

   const filterPrevNotifications = prevNotifications.filter(
      prevNotification => {
         const availableNotification = newNotifications.find(
            newNotification =>
               // eslint-disable-next-line no-underscore-dangle
               prevNotification.__ref === newNotification.__ref
         )
         return !availableNotification
      }
   )

   const finalNotifications = [...filterPrevNotifications, ...newNotifications]

   return {
      ...existing,
      notifications: finalNotifications,
      totalCount: incoming.totalCount
   }
}

export const getDocumentHistory = (existing: any, incoming: any, args) => {
   if (!existing) return incoming
   if (args?.params.pagination.offset === 0) return incoming

   const prevHistory = [...(existing.history || [])]
   const newHistory = [...(incoming.history || [])]

   const filterPrevHistory = prevHistory.filter(prevHistory => {
      const availableHistory = newHistory.find(
         newHistory =>
            // eslint-disable-next-line no-underscore-dangle
            prevHistory.__ref === newHistory.__ref
      )
      return !availableHistory
   })

   const finalHistory = [...filterPrevHistory, ...newHistory]

   return {
      ...existing,
      documentVersions: finalHistory,
      totalCount: incoming.totalCount
   }
}

export const getPipelineItemDocumentTemplates = (
   existing: any,
   incoming: any,
   args
) => {
   if (!existing) return incoming
   if (args?.params.pagination.offset === 0) return incoming

   const prevTemplates = [...(existing.templates || [])]
   const newTemplates = [...(incoming.templates || [])]

   const filterPrevTemplates = prevTemplates.filter(prevTemplate => {
      const availableTemplate = newTemplates.find(
         newTemplate =>
            // eslint-disable-next-line no-underscore-dangle
            prevTemplate.__ref === newTemplate.__ref
      )
      return !availableTemplate
   })

   const finalTemplates = [...filterPrevTemplates, ...newTemplates]

   return {
      ...existing,
      documentTemplates: finalTemplates,
      totalCount: incoming.totalCount
   }
}

export const getScoringRecalculationExecLogs = (
   existing: any,
   incoming: any,
   args: any
) => {
   if (!existing) return incoming
   if (args?.params.pagination.offset === 0) return incoming

   const prevScoringRecalculationLogs = [...(existing.execLogs || [])]
   const newScoringRecalculationLogs = [...(incoming.execLogs || [])]

   const filterPrevScoringRecalculationLogs = prevScoringRecalculationLogs.filter(
      prevLog => {
         const availableLog = newScoringRecalculationLogs.find(
            newLog =>
               // eslint-disable-next-line no-underscore-dangle
               prevLog.__ref === newLog.__ref
         )
         return !availableLog
      }
   )

   const finalScoringRecalculationLogs = [
      ...filterPrevScoringRecalculationLogs,
      ...newScoringRecalculationLogs
   ]

   return {
      ...existing,
      execLogs: finalScoringRecalculationLogs,
      totalCount: incoming.totalCount
   }
}

export const getPluginServiceAccountCallLogs = (
   existing: any,
   incoming: any,
   args: any
) => {
   if (!existing) return incoming
   if (args?.params.pagination.offset === 0) return incoming

   const prevCallLogs = [...(existing.callLogs || [])]
   const newCallLogs = [...(incoming.callLogs || [])]

   const filterPrevCallLogs = prevCallLogs.filter(prevLog => {
      const availableLog = newCallLogs.find(
         newLog =>
            // eslint-disable-next-line no-underscore-dangle
            prevLog.__ref === newLog.__ref
      )
      return !availableLog
   })

   const finalCallLogs = [...filterPrevCallLogs, ...newCallLogs]

   return {
      ...existing,
      callLogs: finalCallLogs,
      totalCount: incoming.totalCount
   }
}

export const getPipelineItemResources = (
   existing: any,
   incoming: any,
   args: any
) => {
   if (!existing) return incoming
   if (args?.params.pagination.offset === 0) return incoming

   const prevResources = [...(existing.resources || [])]
   const newResources = [...(incoming.resources || [])]

   const filterPrevResources = prevResources.filter(prevResource => {
      const availableResource = newResources.find(
         newResource =>
            // eslint-disable-next-line no-underscore-dangle
            prevResource.__ref === newResource.__ref
      )
      return !availableResource
   })

   const finalCallResources = [...filterPrevResources, ...newResources]

   return {
      ...existing,
      resources: finalCallResources,
      totalCount: incoming.totalCount
   }
}

export const getEntityNotes = (existing: any, incoming: any, args: any) => {
   if (!existing) return incoming

   const prevNotes = [...(existing.notes || [])]
   const newNotes = [...(incoming.notes || [])]

   const filterPrevNotes = prevNotes.filter(prevNote => {
      const availableNotes = newNotes.find(
         newNote =>
            // eslint-disable-next-line no-underscore-dangle
            prevNote.__ref === newNote.__ref
      )

      return !availableNotes
   })

   const finalNotes = [...filterPrevNotes, ...newNotes]

   return {
      ...existing,
      notes: finalNotes
   }
}

export const getScrutinyKeyLogs = (existing: any, incoming: any, args: any) => {
   if (!existing) return incoming
   if (args?.params.pagination.offset === 0) return incoming

   const prevScrutinyKeyLogs = [...(existing.logs || [])]
   const newScrutinyKeyLogs = [...(incoming.logs || [])]

   const filterPrevScrutinyKeyLogs = prevScrutinyKeyLogs.filter(prevLog => {
      const availableLog = newScrutinyKeyLogs.find(
         newLog =>
            // eslint-disable-next-line no-underscore-dangle
            prevLog.__ref === newLog.__ref
      )
      return !availableLog
   })

   const finalScrutinyKeyLogs = [
      ...filterPrevScrutinyKeyLogs,
      ...newScrutinyKeyLogs
   ]

   return {
      ...existing,
      logs: finalScrutinyKeyLogs
   }
}

export const searchDocumentVerificationUsers = (
   existing: any,
   incoming: any,
   args: any
) => {
   if (!existing) return incoming
   if (args?.params.pagination.offset === 0) return incoming

   const existingUsers = [...(existing.users || [])]
   const incomingUsers = [...(incoming.users || [])]

   const filterExistingUsers = existingUsers.filter(existingUser => {
      const availableUser = incomingUsers.find(
         // eslint-disable-next-line no-underscore-dangle
         incomingUser => existingUser.__ref === incomingUser.__ref
      )
      return !availableUser
   })

   const mergedUsers = [...filterExistingUsers, ...incomingUsers]

   return {
      ...existing,
      users: mergedUsers,
      totalCount: incoming.totalCount
   }
}

export const getFeeRuleSetLogs = (existing: any, incoming: any, args: any) => {
   if (!existing) return incoming
   if (args?.params.pagination.offset === 0) return incoming

   const prevLogs = [...(existing.logs || [])]
   const newLogs = [...(incoming.logs || [])]

   const filterPrevLogs = prevLogs.filter(prevLog => {
      const availableLog = newLogs.find(
         newLog =>
            // eslint-disable-next-line no-underscore-dangle
            prevLog.__ref === newLog.__ref
      )
      return !availableLog
   })

   const finalLogs = [...filterPrevLogs, ...newLogs]

   return {
      ...existing,
      logs: finalLogs
   }
}

export const getAssignedFriendApplications = (
   existing: any,
   incoming: any,
   args: any
) => {
   if (!existing) return incoming
   if (args?.params.pagination.offset === 0) return incoming

   const existingApplications = [...(existing.applications || [])]
   const incomingApplications = [...(incoming.applications || [])]

   const filterExistingApplications = existingApplications.filter(
      existingApplication => {
         const availableApplication = incomingApplications.find(
            incomingApplication =>
               existingApplication.applicationId ===
               incomingApplication.applicationId
         )
         return !availableApplication
      }
   )

   const mergedApplications = [
      ...filterExistingApplications,
      ...incomingApplications
   ]

   return {
      ...existing,
      applications: mergedApplications,
      totalCount: incoming.totalCount
   }
}

export const searchAndMonitoringApplications = (
   existing: any,
   incoming: any,
   args: any
) => {
   if (!existing) return incoming
   if (args?.params.pagination.offset === 0) return incoming

   const existingApplications = [...(existing.applications || [])]
   const incomingApplications = [...(incoming.applications || [])]

   const filterExistingApplications = existingApplications.filter(
      existingApplication => {
         const availableApplication = incomingApplications.find(
            incomingApplication =>
               // eslint-disable-next-line no-underscore-dangle
               existingApplication.__ref === incomingApplication.__ref
         )
         return !availableApplication
      }
   )

   const mergedApplications = [
      ...filterExistingApplications,
      ...incomingApplications
   ]

   return {
      ...existing,
      applications: mergedApplications,
      totalCount: incoming.totalCount
   }
}

export const getTgBPassApplications = (
   existing: any,
   incoming: any,
   args: any
) => {
   if (!existing) return incoming
   if (args?.params.pagination.offset === 0) return incoming

   const prevApplications = [...(existing.applications || [])]
   const newApplications = [...(incoming.applications || [])]

   const filterPrevApplications = prevApplications.filter(prevApplication => {
      const availableApplication = newApplications.find(
         newApplication =>
            // eslint-disable-next-line no-underscore-dangle
            prevApplication.applicationId === newApplication.applicationId
      )
      return !availableApplication
   })

   const finalApplications = [...filterPrevApplications, ...newApplications]

   return {
      ...existing,
      applications: finalApplications,
      totalCount: incoming.totalCount
   }
}

export const getOfficerManagementUsers = (
   existing: any,
   incoming: any,
   args: any
) => {
   if (!existing) return incoming
   if (args?.params.pagination.offset === 0) return incoming

   const existingUsers = [...(existing.users || [])]
   const incomingUsers = [...(incoming.users || [])]

   const filterExistingUsers = existingUsers.filter(existingUser => {
      const availableUser = incomingUsers.find(
         // eslint-disable-next-line no-underscore-dangle
         incomingUser => existingUser.__ref === incomingUser.__ref
      )
      return !availableUser
   })

   const mergedUsers = [...filterExistingUsers, ...incomingUsers]

   return {
      ...existing,
      users: mergedUsers,
      totalCount: incoming.totalCount
   }
}

export const searchUsernames = (existing: any, incoming: any, args: any) => {
   if (!existing) return incoming
   if (args?.params.pagination.offset === 0) return incoming

   const existingUsernames = [...(existing.usernames || [])]
   const incomingUsernames = [...(incoming.usernames || [])]

   const filterExistingUsernames = existingUsernames.filter(
      existingUsername => {
         const availableUsername = incomingUsernames.find(
            incomingUsername => existingUsername === incomingUsername
         )
         return !availableUsername
      }
   )

   const mergedUsernames = [...filterExistingUsernames, ...incomingUsernames]

   return {
      ...existing,
      usernames: mergedUsernames,
      totalCount: incoming.totalCount
   }
}

export const getOfficerLeaveLogs = (
   existing: any,
   incoming: any,
   args: any
) => {
   if (!existing) return incoming
   if (args?.params.pagination.offset === 0) return incoming

   const existingUsers = [...(existing.users || [])]
   const incomingUsers = [...(incoming.users || [])]

   const filterExistingUsers = existingUsers.filter(existingUser => {
      const availableUser = incomingUsers.find(
         // eslint-disable-next-line no-underscore-dangle
         incomingUser => existingUser.__ref === incomingUser.__ref
      )
      return !availableUser
   })

   const mergedUsers = [...filterExistingUsers, ...incomingUsers]

   return {
      ...existing,
      users: mergedUsers,
      totalCount: incoming.totalCount
   }
}

export const getOfficerManagementLogs = (
   existing: any,
   incoming: any,
   args: any
) => {
   if (!existing) return incoming
   if (args?.params.filters.pagination.offset === 0) return incoming

   const existingRequests = [...(existing.requests || [])]
   const incomingRequests = [...(incoming.requests || [])]

   const filterExistingRequests = existingRequests.filter(existingRequest => {
      const availableRequest = incomingRequests.find(
         incomingRequest =>
            // eslint-disable-next-line no-underscore-dangle
            existingRequest.__ref === incomingRequest.__ref
      )
      return !availableRequest
   })

   const mergedRequests = [...filterExistingRequests, ...incomingRequests]

   return {
      ...existing,
      requests: mergedRequests,
      totalCount: incoming.totalCount
   }
}

export const searchOfficerManagementUsers = (
   existing: any,
   incoming: any,
   args: any
) => {
   if (!existing) return incoming
   if (args?.params.pagination.offset === 0) return incoming

   const existingUsers = [...(existing.users || [])]
   const incomingUsers = [...(incoming.users || [])]

   const filterExistingUsers = existingUsers.filter(existingUser => {
      const availableUser = incomingUsers.find(
         // eslint-disable-next-line no-underscore-dangle
         incomingUser => existingUser.__ref === incomingUser.__ref
      )
      return !availableUser
   })

   const mergedUsers = [...filterExistingUsers, ...incomingUsers]

   return {
      ...existing,
      users: mergedUsers,
      totalCount: incoming.totalCount
   }
}

export const getApplicationsInApplicationManagement = (
   existing: any,
   incoming: any,
   args: any
) => {
   if (!existing) return incoming
   if (args?.params.pagination.offset === 0) return incoming

   const existingApplications = [...(existing.applications || [])]
   const incomingApplications = [...(incoming.applications || [])]

   const filterExistingApplications = existingApplications.filter(
      existingApplication => {
         const availableApplication = incomingApplications.find(
            incomingApplication =>
               existingApplication.pipelineItemId ===
               incomingApplication.pipelineItemId
         )
         return !availableApplication
      }
   )

   const mergedApplications = [
      ...filterExistingApplications,
      ...incomingApplications
   ]

   return {
      ...existing,
      applications: mergedApplications,
      totalCount: incoming.totalCount
   }
}

export const getTdrManagementLogs = (
   existing: any,
   incoming: any,
   args: any
) => {
   if (!existing) return incoming
   if (args?.params.pagination.offset === 0) return incoming

   const existingLogs = [...(existing.logs || [])]
   const incomingLogs = [...(incoming.logs || [])]

   const filterExistingLogs = existingLogs.filter(existingLog => {
      const availableLog = incomingLogs.find(
         incomingLog =>
            // eslint-disable-next-line no-underscore-dangle
            existingLog.logId === incomingLog.logId
      )
      return !availableLog
   })

   const mergedLogs = [...filterExistingLogs, ...incomingLogs]

   return {
      ...existing,
      logs: mergedLogs,
      totalCount: incoming.totalCount
   }
}

export const getOnHoldTdrAccountLogs = (
   existing: any,
   incoming: any,
   args: any
) => {
   if (!existing) return incoming
   if (args?.params.pagination.offset === 0) return incoming

   const existingLogs = [...(existing.logs || [])]
   const incomingLogs = [...(incoming.logs || [])]

   const filterExistingLogs = existingLogs.filter(existingLog => {
      const availableLog = incomingLogs.find(
         incomingLog =>
            // eslint-disable-next-line no-underscore-dangle
            existingLog.logId === incomingLog.logId
      )
      return !availableLog
   })

   const mergedLogs = [...filterExistingLogs, ...incomingLogs]

   return {
      ...existing,
      logs: mergedLogs,
      totalCount: incoming.totalCount
   }
}
